import axios from 'axios'
import { logger } from '@/logger'
import { get, httpDelete, post } from '@/api/AxiosUtil'

function getArchives() {
  return get('/api/v2/filestore/archives')
}

function getFolders() {
  return get(`/api/v2/filestore/folders`)
}

function getFilesForFolder(folderId) {
  return get(`/api/v2/filestore/folder/${folderId}/file`)
}

function trashGetArchives() {
  return get(`/json/trash-get.json.php`)
}

function trashGet(folderId) {
  return post(`/json/trash-get.json.php`, { folderId: folderId })
}

function userList(folderId) {
  return post(`/json/user-list.json.php`, { folderId: folderId })
}

function userCancel(folderId, email) {
  return post(`/json/user-cancel.json.php`, {
    folderId: folderId,
    email: email
  })
}

function userRemove(folderId, userId) {
  return post(`/json/user-set.json.php`, {
    folderId: folderId,
    userId: userId,
    accessLevel: 'remove'
  })
}

function getOrder(id) {
  return get(`/api/v2/order/${id}`)
}

function repeatOrder(sessionId, orderId) {
  return post(`/api/v3/secure/order-repeat`, {
    sessionId: sessionId,
    orderId: orderId
  })
}

function addArchive(archiveName, billingAddressId) {
  return new Promise((resolve, reject) => {
    axios
      .post('/json/folder-add.json.php', {
        folderName: archiveName,
        billingAddressId: billingAddressId
      })
      .then((response) => {
        if (response.data.error) {
          reject({ message: response.data.message })
        } else {
          resolve(response.data.newArchive)
        }
      })
      .catch((error) => reject(error))
  })
}

function addFolder(parentId, name) {
  return new Promise((resolve, reject) => {
    axios
      .post('/api/v2/filestore/folder', {
        parentId: parentId,
        folderName: name
      })
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        logger.error(error.message)
        reject(error.response.data.exception[0]?.message)
      })
  })
}

function trashFiles(fileIds) {
  return httpDelete('/api/v2/filestore/file', { fileIds: fileIds })
}

function deleteFiles(fileIds) {
  return post('/json/file-delete.json.php', {
    fileIds: fileIds,
    wipe: true
  })
}

function trashFolder(folderId) {
  return post('/json/folder-delete.json.php', {
    folderId: folderId
  })
}

function deleteFolder(folderId) {
  return post('/json/folder-delete.json.php', {
    folderId: folderId,
    wipe: true
  })
}

function emptyTrash(folderId) {
  return post('/json/trash-empty.json.php', { folderId: folderId })
}

function restoreFile(fileId) {
  return post('/json/file-restore.json.php', {
    fileId: fileId
  })
}

function restoreFolder(folderId) {
  return post('/json/folder-restore.json.php', {
    folderId: folderId
  })
}

/*
  options object:
  - searchString - required
  - includeTrash - optional, default true
  - folderId - optional
 */
function searchFileStore(options) {
  const defaultOptions = {
    includeTrash: true
  }
  const searchOptions = {
    ...defaultOptions,
    ...options
  }
  return new Promise((resolve, reject) => {
    let url

    if (searchOptions.folderId) {
      url = `/api/v2/search?searchString=${searchOptions.searchString}&folderId=${searchOptions.folderId}&includeTrash=${searchOptions.includeTrash}`
    } else {
      url = `/api/v2/search?searchString=${searchOptions.searchString}&includeTrash=${searchOptions.includeTrash}`
    }

    axios
      .get(url)
      .then((response) => resolve(response.data))
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

function deleteArchive(archive) {
  return post('/json/folder-delete.json.php', {
    folderId: archive.folderId
  })
}

function updateSetting(setting) {
  return post('/api/v2/user', setting)
}

export {
  getArchives,
  getOrder,
  repeatOrder,
  getFolders,
  getFilesForFolder,
  searchFileStore,
  addFolder,
  trashFolder,
  deleteFolder,
  trashFiles,
  deleteFiles,
  restoreFile,
  restoreFolder,
  addArchive,
  updateSetting,
  deleteArchive,
  emptyTrash,
  userList,
  userCancel,
  userRemove,
  trashGet,
  trashGetArchives
}
